module.exports = __webpack_public_path__ + "img/consent-collection-widget-top-right.ada7a28d.svg";